import { createAsyncThunk } from "@reduxjs/toolkit";
import { editStrategy } from "features/Strategy/service";

import { parseErrorMessage } from "utils";

export const editEtfStrategy = createAsyncThunk(
  "strategy/etf/edit",
  async (data, thunkAPI) => {
    try {
      const response = await editStrategy(data);
      return response;
    } catch (error) {
      const msg = parseErrorMessage(error);
      return thunkAPI.rejectWithValue({ error: msg });
    }
  }
);
